export default __webpack_public_path__ + "static/media/downloadArrow.fdb5dbdf.svg";